export const canonicalRoutes = {
  home: '/',
  today: '/home',
  read: '/read',
  dict: '/dict',
  grammar: '/grammar',
  collections: '/collections',
  blog: '/blog',
  settings: '/settings',
  onboarding: '/onboarding',
  login: '/login',
  readImport: '/read/import',
  readMusic: '/read/music',
  pinyin: '/pinyin',
  zhuyin: '/zhuyin'
} as const

export type ProductNavKey =
  | 'today'
  | 'read'
  | 'dict'
  | 'grammar'
  | 'collections'

export const productNavItems: Array<{
  key: ProductNavKey
  label: string
  href: string
}> = [
  { key: 'today', label: 'Home', href: canonicalRoutes.today },
  { key: 'read', label: 'Reader', href: canonicalRoutes.read },
  { key: 'dict', label: 'Dictionary', href: canonicalRoutes.dict },
  { key: 'grammar', label: 'Grammar', href: canonicalRoutes.grammar },
  {
    key: 'collections',
    label: 'Decks',
    href: canonicalRoutes.collections
  }
]

export function trimTrailingSlash(pathname: string) {
  if (pathname.length <= 1) return pathname || '/'
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
}

export function isActiveProductRoute(pathname: string, href: string) {
  const current = trimTrailingSlash(pathname)
  const target = trimTrailingSlash(href)

  return current === target || current.startsWith(`${target}/`)
}

export function isImmersiveReaderRoute(pathname: string) {
  const current = trimTrailingSlash(pathname)

  if (
    current.startsWith('/read/document/') ||
    current.startsWith('/read/lyrics/')
  ) {
    return true
  }

  if (!current.startsWith('/read/')) return false
  if (
    current === '/read/import' ||
    current === '/read/music' ||
    current === '/read/idioms' ||
    current.startsWith('/read/idioms/')
  ) {
    return false
  }

  return current.split('/').filter(Boolean).length === 2
}

export async function stringifySearchParams(
  searchParams:
    | Promise<Record<string, string | string[] | undefined>>
    | Record<string, string | string[] | undefined>
    | undefined
) {
  const resolved = searchParams ? await searchParams : {}
  const params = new URLSearchParams()

  for (const [key, value] of Object.entries(resolved)) {
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, item))
    } else if (typeof value === 'string') {
      params.set(key, value)
    }
  }

  const search = params.toString()
  return search ? `?${search}` : ''
}
